import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop({ targetRef }) {
  const { pathname } = useLocation();

  useEffect(() => {
    if (targetRef?.current) {
      // Scroll your internal div
      targetRef.current.scrollTo({ top: 0, behavior: "instant" });
    } else {
      // Fallback to window scroll
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [pathname]);

  return null;
}
